export const headerDataMission = {
    title: 'Mission',
    submodules: [
        createData(0, "Mes demandes d'appui", "/mission/demande"),
        createData(1, "Planification", "/mission/planning_mission"),
        createData(2, "Acceptation demande d'appui", "/acceptedHelp"),
        createData(3, "Elaboration TDR", "/mission/elaboration_tdr"),
        createData(4, "Elaboration Agenda", "/mission/agendalist"),
        createData(5, "TimeSheet", "/mission/timesheet"),
        createData(6, "Ordre des missions", "/mission/om"),


    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}